/**
 * 폴링 및 타임아웃 관련 상수
 * 비동기 작업의 진행 상태 확인에 사용
 */

/** 오디오 내보내기 폴링 간격 (ms) */
export const EXPORT_POLLING_INTERVAL_MS = 5000;

/** 오디오 내보내기 타임아웃 (ms) - 5분 */
export const EXPORT_POLLING_TIMEOUT_MS = 300000;

/** WAV 변환 폴링 간격 (ms) */
export const WAV_POLLING_INTERVAL_MS = 5000;

/** YouTube 최소 예약 시간 오프셋 (ms) - 1시간 */
export const YOUTUBE_MIN_SCHEDULE_OFFSET_MS = 60 * 60 * 1000;
